
import AnimatedCard from "../AnimatedCard";

interface SectionHeaderProps {
  title: string;
  highlightedText: string;
  description: string;
  centered?: boolean;  // Added this optional prop
}

const SectionHeader = ({ title, highlightedText, description, centered = true }: SectionHeaderProps) => {
  return (
    <AnimatedCard animation="fade-in">
      <div className={`${centered ? 'text-center' : ''} mb-16`}>
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          <span className="text-gradient">{highlightedText}</span>{" "}
          <span className="text-white">{title}</span>
        </h2>
        <p className="text-lg text-white/70 max-w-3xl mx-auto">
          {description}
        </p>
      </div>
    </AnimatedCard>
  );
};

export default SectionHeader;
